/**
 * PageHeader (P26).
 *
 * Lifted from `sample-wireframe/client/src/pages/Home.tsx`. Every routed
 * page that isn't a wizard uses this header — eyebrow + title + description
 * + right-aligned action cluster.
 */
import type { JSX, ReactNode } from 'react';

interface PageHeaderProps {
  eyebrow: string;
  title: string;
  description: string;
  children?: ReactNode;
}

export function PageHeader({
  eyebrow,
  title,
  description,
  children,
}: PageHeaderProps): JSX.Element {
  return (
    <div className="page-header">
      <div>
        <div className="eyebrow">{eyebrow}</div>
        <h1>{title}</h1>
        <p>{description}</p>
      </div>
      {children ? <div className="page-actions">{children}</div> : null}
    </div>
  );
}
